import { NUULY_BRAND, URBN_BRANDS } from '~coreModules/core/js/constants';

/**
 * @description
 * Generates product slug based on the current route
 *
 * @param   {Object} vm        vue component runtime object
 *
 * @returns  {string}   Formatted product module name
 */
export function getProductModuleName(vm) {
    const slug = vm?.$route?.params?.slug ?? 'unknown';
    return `product--${slug}`;
}

/**
 * @description
 * Generates product slug based on the current route
 *
 * @param   {Object} route        vue route
 *
 * @returns  {string}   Formatted product module name
 */
export function getProductModuleNameFromRoute(route) {
    const slug = route?.params?.slug ?? 'unknown';
    return `product--${slug}`;
}

/**
 * @description
 * Returns the product brand display name
 *
 * @param   {Array} vendorBrands    Array of vendor brands
 * @param   {string} filterKey    Key to filter by
 *
 * @returns  {string}   Filtered brand name
 */
export function getFilteredVendorBrands(vendorBrands, filterKey = '') {
    let brands = vendorBrands;
    if (!brands?.length) return '';
    if (brands?.length > 1) {
        brands = brands.filter((brand) => {
            const brandName = filterKey ? brand[filterKey] : brand;
            return !URBN_BRANDS.includes(brandName);
        });

        const nuulyBrand = brands.find((brand) => {
            const brandName = filterKey ? brand[filterKey] : brand;
            return brandName.includes(NUULY_BRAND);
        });

        if (nuulyBrand) {
            return nuulyBrand;
        }
    }

    return brands[0];
}
